export default __webpack_public_path__ + "static/media/Skirmisher's Spell Glaive.3a9763f3.jpg";